import { keyBy } from "lodash";

export const SAT_GC = "GC";
export const SAT_IP = "IP";
export const SAT_ED = "ED";
export const SAT_MD = "MD";

export const appList = [
    { label: "GC", key: SAT_GC },
    { label: "IP", key: SAT_IP },
    { label: "ED", key: SAT_ED },
    { label: "MILK DONATION", key: SAT_MD }
];

export const appMap = getMapByList(appList);

export function getAppLabelByKey(key) {
    return getAppByKey(key)?.label || key;
}

export function getAppByKey(key) {
    return appMap?.[key];
}

export const SST_PUBLISH = "PUBLISH";
export const SST_CONSTRUCT = "CONSTRUCT";
export const SST_ACTIVE = "ACTIVE";
export const SST_ARCHIVED = "ARCHIVED";

export const statusList = [
    { label: "Published", key: SST_PUBLISH },
    { label: "Under construction", key: SST_CONSTRUCT },
    { label: "Active", key: SST_ACTIVE },
    { label: "Archived", key: SST_ARCHIVED }
];

export const statusMap = getMapByList(statusList);

export function getStatusLabelByKey(key) {
    return getStatusByKey(key)?.label || key;
}

export function getStatusByKey(key) {
    return statusMap?.[key];
}

function getMapByList(list, key = "key") {
    return keyBy(list, key);
}
